module.exports = __webpack_public_path__ + "static/media/oldThree_v2.0299dcf4.jpg";